import type { FaireProductEntity } from "../../entity_types/product";

export const p_6f7sshvf92: FaireProductEntity = {
  token: "p_6f7sshvf92",
  type: "product",
  name: "Zodiac Birthstone Build Your Own Necklace Set - 12 Set",
  brandToken: "b_b8csz3xa8h",
  brandName: "Gypsy Soul",
  imageUrl:
    "https://cdn.faire.com/fastly/e059ee3648cca2a84d21685d0aa66e7625359ed3e40267445c5d577130c394ae.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e4b465df1186666c248a67ca6f704b738e48261e8683106d1950e7b42ac7a9fb.jpeg",
    "https://cdn.faire.com/fastly/2431b6f51b54eec734c2290d8f9174d0402104e8b065e75cf9762298a5148545.webp",
    "https://cdn.faire.com/fastly/02732730041be11e07f9aca50c8c49844627b95fe29f5c9cea4cc8d4f5c496e4.webp",
    "https://cdn.faire.com/fastly/ab32ba5605be06604cd95c85beeb8cd7bbcb7394eeadf1d348786edf5da32ad8.webp",
    "https://cdn.faire.com/fastly/58f92bd2d1ae842a9cdb3ba9bc49988c8847954ea4943bce0f292b74421484b7.webp",
    "https://cdn.faire.com/fastly/6c20349327e73855a9718f8bcccf4b2dcfdde313e3448f3a9da16091604ed772.webp",
    "https://cdn.faire.com/fastly/6985f3d82748c247864b072d7247e7c5ccbee48de826fc6b45ab1e1d287d4ed7.webp",
    "https://cdn.faire.com/fastly/5d2e6adfb73fcde70892ad00d6508beec6b4785eb472a46d77dad143985cb962.webp",
    "https://cdn.faire.com/fastly/a97d0a80f2e585ffc6812789995602e33a144197a193d2f6f58d183aae7e5ee6.webp",
    "https://cdn.faire.com/fastly/38bb78c75f947c2696de6660a021ed7bd403e4c311b5412cdc5f5a56db14e5f7.webp",
    "https://cdn.faire.com/fastly/7c4bdf5035ce65592d66c1d13bb8d7c5f4df4328147314d3c6f348d28b54ced5.webp",
    "https://cdn.faire.com/fastly/2f539323d0a33d6a615db13fced06c904ba01a9a9fe35a02788a25d5746b68c4.webp",
  ],
  priceDollars: 11.07,
  description:
    "Unlock the celestial energy of the cosmos and embrace your unique astrological essence with our zodiac birthstone necklace set. Crafted with intention and care, this customizable set allows you to create a personalized necklace that resonates with your zodiac sign and harnesses the healing properties of your birthstone.\n\nThe centerpiece of your necklace is a genuine birthstone crystal corresponding to your zodiac sign. From the fiery red of garnet for January-born Capricorns to the serene blue of Apatite for March-born Pisces, these crystals resonate with the energy of your astrological sign, offering healing, protection, and spiritual guidance.\n\nPackage content:\n1 case contains 12 zodiac necklace set.",
  tags: [],
  msrpDollars: 23.54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:25.058Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
